<template>
    <div class="background">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "Défipix",
}
</script>

<style>
* {
  font-family: 'Montserrat', sans-serif;
}

#dpLogo {
    width: 6em;
    margin: -1em 0 -1em 0;
}

.background {
    background-image: url(https://preprod.api.defipix.fr/logos/pattern.png);
    background-repeat: repeat;
    background-attachment: fixed;
    min-height: 100vh;
}

i {
    margin: 0 10px;
}

#deconnexionBtn {
    width: 2em;
    margin: auto;
}

.navbar {
    background-color: #00093a;
}

input[type=text],
input[type=number],
input[type=email],
input[type=tel],
input[type=password],
input[type=date] {
    width: 100%;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #25327B;
    font-weight: bold;
}

textarea:focus, input:focus{
    outline: none;
}

input:hover {
    border: 1px solid #0070cd;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}

/* Style of date picker */
.selected {
    color: white;
    background-color: #25327B !important;
}

.vdp-datepicker__calendar {
    width: 100% !important;
    border: 1px solid #25327B !important;
    border-radius: 5px;
}

.day-header {
    color: #25327B !important;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #25327B !important;
}

</style>


// WEBPACK FOOTER //
// src/App.vue